<div class="w-auto">

    <div class="filters">
      <button class="button-filter" [class.buttonSelected]='filters.typeId[typeFilterEnum.Line]' (click)="onSelectButtonsType('typeId', typeFilterEnum.Stop, typeFilterEnum.Line)">Líneas</button>
      <button class="button-filter" [class.buttonSelected]='filters.typeId[typeFilterEnum.Stop]' (click)="onSelectButtonsType('typeId', typeFilterEnum.Line, typeFilterEnum.Stop)">Paradas</button>
      <a class="serch subtitle-card cursor-pointer" (click)="cleanFilter()">
        Limpiar
      </a>
    </div>

    <div class="mt-24">
        <ng-container *ngIf="filters.typeId[typeFilterEnum.Line]">
            <mat-form-field appearance="outline">
                <mat-label>Líneas</mat-label>
                <mat-select [(value)]="filters.lineId">
                <mat-option *ngFor="let line of filterLinesOptions" [value]="line.value">{{ line.label }}</mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *ngIf="filters.typeId[typeFilterEnum.Stop]">
            <mat-form-field appearance="outline">
                <mat-label>Parada</mat-label>
                <mat-select [(value)]="filters.stopId">
                  <mat-option *ngFor="let stop of filterStopsOptions" [value]="stop.value">{{ stop.label }}</mat-option>
                </mat-select>
              </mat-form-field>
        </ng-container>
    </div>

    <div class="footer-buttons">
      <button class="button-apply" (click)="applyFilter()">APLICAR</button>
    </div>
  </div>
